import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Form, Row, Col, Select, DatePicker, Button} from 'antd'
import moment from 'moment'
import {withTranslation} from 'react-i18next'

const {RangePicker} = DatePicker

@inject('homeStore')
@observer
class FormModal extends Component {
  state = {
    dates: [],
    shortName: '',
    messageCustomer: [],
    messageShortName: [],
  }
  formRef = React.createRef()

  componentDidMount() {
    const {homeStore} = this.props
    const {customerList} = homeStore
    this.setState({
      shortName: customerList,
      messageCustomer: homeStore.messageCustomer,
      messageShortName: homeStore.messageShortName,
    })
    this.formRef.current.setFieldsValue({
      createDate: [moment(), moment()]
    })
  }

  componentWillReceiveProps(nextProps) {
    const {homeStore} = nextProps
    const {messageCustomer, messageShortName} = homeStore
    if (messageCustomer.length > 0) {
      this.formRef.current.setFieldsValue({
        customer: Array.from(messageCustomer),
        shortName: Array.from(messageShortName),
      })
    }
    this.setState({
      messageCustomer: messageCustomer,
      messageShortName: messageShortName,
    })
  }

  handleOk = () => {
    const {homeStore} = this.props
    const {shortNames} = homeStore
    this.formRef.current.validateFields().then(fieldsValue => {
      if (fieldsValue.createDate === undefined || fieldsValue.createDate === null || fieldsValue.createDate === [] || fieldsValue.createDate.length === 0 || fieldsValue.createDate === 'Invalid date') {
        fieldsValue.createDate = [moment().format('YYYY-MM-DD') + ' 00:00:00', '']
      }
      const startDate = fieldsValue.createDate[0] === '' ? '' : moment(fieldsValue.createDate[0]).format('YYYY-MM-DD') + ' 00:00:00'
      const endDate = fieldsValue.createDate[1] === '' || fieldsValue.createDate[1] === null ? '' : moment(fieldsValue.createDate[1]).format('YYYY-MM-DD') + ' 23:59:59'
      const newShortNames = []
      for (let i = 0; i < fieldsValue.shortName.length; i++) {
        shortNames.filter(item => item.shortName === fieldsValue.shortName[i]).map(it => {
          return newShortNames.push({
            customer: it.customer,
            shortName: it.shortName
          })
        })
      }
      homeStore.onGetBusinessAction({
        startTime: startDate,
        endTime: endDate,
      }).then()
      homeStore.onSearchMessageAction({
        startTime: startDate,
        endTime: endDate,
        messageDistributionCustomerVoList: homeStore.onChangeCustomer(newShortNames),
      }).then()
      homeStore.onSearchMessageDistributionAction({
        startTime: startDate,
        endTime: endDate,
        messageDistributionCustomerVoList: homeStore.onChangeCustomer(newShortNames),
      }).then()
      homeStore.onSaveCountAction({
        messageCustomer: JSON.stringify(fieldsValue.customer),
        messageShortName: JSON.stringify(fieldsValue.shortName)
      }).then()
      homeStore.onSearchApiStateAction({customers: fieldsValue.customer})
    })
  }

  setDates(value) {
    this.setState({
      dates: value
    })
  }

  disabledDate = current => {
    return current >= moment().endOf('day')
  }

  /*change Message Statistics customer - change Message Distribution customer*/
  onChange = (value) => {
    const {homeStore} = this.props
    // homeStore.clearMessageShortName()
    if (value.length > 0) {
      homeStore.onChangeMessageCustomer(value)
      homeStore.onGetShortName({
        'customers': value
      }).then(res => {
        const shortNamesArr = []
        if (res.data.code === 0) {
          for (let k = 0; k < res.data.data.length; k++) {
            homeStore.messageShortName.filter(item => item === res.data.data[k].shortName).map(it => shortNamesArr.push(it))
          }
        }
        homeStore.onChangeMessageShortName(shortNamesArr)
        this.formRef.current.setFieldsValue({
          shortName: shortNamesArr,
        })
      })
    }
    this.setState({
      shortName: value
    })
    if (!value.length > 0) {
      this.formRef.current.setFieldsValue({
        shortName: [],
      })
      this.setState({
        shortName: ''
      })
    }
  }
  onChangeShortName = (value) => {
    const {homeStore} = this.props
    homeStore.onChangeMessageShortName(value)
  }

  render() {
    const {homeStore, t} = this.props
    const {customerList, shortNames} = homeStore

    return (
      <>
        <Form ref={this.formRef} key="homeFilter" className="rightSearch">
          <Row>
            <Col span={7} style={{paddingRight: 10}}>
              <Form.Item name="customer" label={t('home.customer')}
                         rules={[{required: true, message: `${t('general.pleaseSelect')} ${t('home.customer')}`}]}
                         htmlFor={null}>
                <Select placeholder={t('general.pleaseSelect')} allowClear showArrow mode="multiple" maxTagCount="responsive"
                        maxTagTextLength={10} onChange={this.onChange} filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }>
                  {customerList.length > 0 ? customerList.map(item => <Select.Option key={item.id}
                                                                                     value={item.id}>{item.customer}</Select.Option>) : null}
                </Select>
              </Form.Item>
            </Col>
            <Col span={7} style={{paddingRight: 10}}>
              <Form.Item name="shortName" label={t('home.connectShortName')}
                         rules={[{required: true, message: `${t('general.pleaseSelect')} ${t('home.connectShortName')}`}]} htmlFor={null}>
                <Select placeholder={t('general.pleaseSelect')} allowClear showArrow mode="multiple" maxTagCount="responsive"
                        maxTagTextLength={10} onChange={this.onChangeShortName}
                        disabled={this.state.shortName === ''}
                >
                  {
                    shortNames.length > 0 ? shortNames.map(item => <Select.Option key={item.shortName}
                                                                                  value={item.shortName}>{item.shortName}</Select.Option>) : null
                  }

                </Select>
              </Form.Item>
            </Col>
            <Col span={7}>
              <Form.Item name="createDate" label={t('home.timeRange')} htmlFor={null}
                         rules={[{required: true, message: `${t('general.pleaseSelect')} ${t('home.timeRange')}`}]}>
                <RangePicker
                  format="YYYY-MM-DD"
                  disabledDate={this.disabledDate}
                  style={{width: '100%'}}
                  allowClear key="RangePicker"
                  onCalendarChange={val => this.setDates(val)}
                  // defaultValue={[moment(), moment()]}
                />
              </Form.Item>
            </Col>
            <Col span={3} style={{textAlign: 'right'}}>
              <Button key="Save" type="primary" onClick={this.handleOk}>{t('general.search')}</Button>
            </Col>
          </Row>
        </Form>
      </>
    )
  }
}

export default withTranslation()(FormModal)
